import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_mst_entity_grp_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  description: fromDatatype.TextDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  log_json: fromDatatype.JsonDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_fi_mst_entity_grp_hdr_RowClass
  implements bl_fi_mst_entity_grp_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  description: fromDatatype.TextDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  log_json: fromDatatype.JsonDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}
